import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface DialogData { 
  row:any
}

@Component({
  selector: 'app-ver-datos-usuario-por-servicio',
  templateUrl: './ver-datos-usuario-por-servicio.component.html',
  styleUrls: ['./ver-datos-usuario-por-servicio.component.scss']
})
export class VerDatosUsuarioPorServicioComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<VerDatosUsuarioPorServicioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
  }

}
